import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';

export const Services = () => {
  const mainServices = [
    {
      icon: 'fa-calendar-check',
      title: 'Agendamento',
      subtitle: 'Atendimento e consulta inicial',
      description:
        'Agende uma conversa com nossa equipe para análise inicial do seu caso, sem compromisso e com orientação clara sobre os próximos passos.',
      features: [
        'Análise inicial gratuita',
        'Atendimento presencial ou online',
        'Orientação sobre os documentos necessários',
      ],
    },
    {
      icon: 'fa-notes-medical',
      title: 'Auxílio-Doença',
      subtitle: 'Incapacidade temporária',
      description:
        'Assessoria para concessão, prorrogação e recurso do auxílio por incapacidade temporária em casos de doença ou acidente.',
      features: [
        'Requerimento e agendamento de perícia',
        'Recurso em caso de indeferimento',
        'Prorrogação e restabelecimento',
      ],
    },
    {
      icon: 'fa-clock',
      title: 'Aposentadoria por Tempo de Contribuição',
      subtitle: 'Planejamento completo',
      description:
        'Análise especializada para quem já contribuiu por tempo suficiente e deseja garantir o melhor benefício possível.',
      features: [
        'Revisão do tempo de contribuição',
        'Averbação de tempo de serviço',
        'Cálculo e planejamento previdenciário',
      ],
    },
    {
      icon: 'fa-user-clock',
      title: 'Aposentadoria por Idade',
      subtitle: 'Urbana, rural ou híbrida',
      description:
        'Assessoria completa para solicitação da aposentadoria por idade, garantindo todos os benefícios a que você tem direito.',
      features: [
        'Análise de idade e carência',
        'Comprovação de atividade rural',
        'Acompanhamento do processo no INSS',
      ],
    },
    {
      icon: 'fa-car-crash',
      title: 'Auxílio-Acidente',
      subtitle: 'Sequelas de acidentes',
      description:
        'Benefício para trabalhadores que sofrem redução da capacidade laborativa em decorrência de acidente.',
      features: [
        'Análise de sequelas permanentes',
        'Acompanhamento de perícia médica',
        'Documentação e recursos',
      ],
    },
    {
      icon: 'fa-heart-broken',
      title: 'Pensão por Morte',
      subtitle: 'Benefício para dependentes',
      description:
        'Assessoria completa para solicitação de pensão por morte para dependentes de segurado falecido.',
      features: [
        'Identificação de dependentes',
        'Cálculo do benefício e da duração',
        'Comprovação de união estável',
      ],
    },
    {
      icon: 'fa-shield-alt',
      title: 'Aposentadoria Especial',
      subtitle: 'Atividades insalubres e perigosas',
      description:
        'Especialistas em reconhecimento de atividades especiais e insalubres para garantir sua aposentadoria com tempo reduzido.',
      features: [
        'Identificação de períodos especiais',
        'Análise de PPP e LTCAT',
        'Conversão de tempo especial',
      ],
    },
    {
      icon: 'fa-wheelchair',
      title: 'Benefício por Incapacidade Permanente (Invalidez)',
      subtitle: 'Antiga aposentadoria por invalidez',
      description:
        'Atuação para concessão do benefício a quem está permanentemente incapaz para o trabalho, inclusive com o acréscimo de 25%.',
      features: [
        'Instrução médica do processo',
        'Conversão do auxílio-doença',
        'Adicional de 25% quando cabível',
      ],
    },
    {
      icon: 'fa-hands-helping',
      title: 'BPC / LOAS (Idoso / Deficiente)',
      subtitle: 'Benefício assistencial',
      description:
        'Benefício de prestação continuada para idosos a partir de 65 anos e pessoas com deficiência de baixa renda.',
      features: [
        'Análise de elegibilidade e renda',
        'CadÚnico e documentação',
        'Recursos em caso de negativa',
      ],
    },
    {
      icon: 'fa-baby',
      title: 'Salário-Maternidade',
      subtitle: 'Gestantes e adotantes',
      description:
        'Orientação completa para solicitação do salário-maternidade: empregadas, autônomas, rurais e desempregadas.',
      features: [
        'Análise de carência e qualidade de segurada',
        'Cálculo do benefício',
        'Recurso em caso de negativa',
      ],
    },
    {
      icon: 'fa-sync-alt',
      title: 'Revisões de Benefícios do INSS',
      subtitle: 'Aumento de valor e atrasados',
      description:
        'Análise detalhada do seu benefício para identificar possibilidades de revisão e aumento de valores com pagamento de atrasados.',
      features: [
        'Revisão de tempo de contribuição',
        'Revisão de atividade especial',
        'Reajuste do salário-de-benefício',
      ],
    },
    {
      icon: 'fa-calculator',
      title: 'Cálculo e Análise de Requisitos para Aposentar',
      subtitle: 'Planejamento previdenciário',
      description:
        'Simulação e análise do seu histórico contributivo para definir o melhor momento e a melhor regra de aposentadoria.',
      features: [
        'Análise do CNIS e do histórico de contribuições',
        'Comparação entre as regras de transição',
        'Cálculo do melhor momento para se aposentar',
      ],
    },
    {
      icon: 'fa-file-medical',
      title: 'Outros Benefícios',
      subtitle: 'Demais benefícios do INSS',
      description:
        'Atuação nos demais benefícios previdenciários, como auxílio-reclusão, salário-família e seguro-defeso.',
      features: [
        'Análise personalizada do caso',
        'Requerimento administrativo',
        'Atuação judicial quando necessário',
      ],
    },
  ];

  const otherAreas = [
    {
      icon: 'fa-briefcase',
      area: 'Trabalhista',
      title: 'Reclamações Trabalhistas e Outros',
      description:
        'Defesa dos seus direitos na Justiça do Trabalho: verbas rescisórias, horas extras, reconhecimento de vínculo e demais demandas trabalhistas.',
    },
    {
      icon: 'fa-file-invoice-dollar',
      area: 'Tributário',
      title: 'Planejamento e Defesa Fiscal',
      description:
        'Planejamento tributário para pessoas físicas e empresas, além de defesa em autos de infração e processos administrativos e judiciais.',
    },
    {
      icon: 'fa-hand-holding-usd',
      area: 'Tributário',
      title: 'Isenção e Restituição de Impostos',
      description:
        'Pedidos de isenção de imposto de renda, inclusive em casos de doença grave, e recuperação de valores pagos indevidamente.',
    },
    {
      icon: 'fa-university',
      area: 'Bancário',
      title: 'Revisão de Contratos',
      description:
        'Revisão de contratos bancários e de financiamento para identificar juros abusivos, cobranças indevidas e cláusulas ilegais.',
    },
  ];

  const faq = [
    {
      question: 'Quando posso me aposentar?',
      answer:
        'O momento ideal para se aposentar varia conforme sua idade, tempo de contribuição e tipo de atividade exercida. Nossa equipe realiza uma análise detalhada do seu histórico para identificar a melhor opção e o momento mais vantajoso.',
    },
    {
      question: 'Como funciona a revisão de benefícios?',
      answer:
        'A revisão de benefícios é um procedimento que permite corrigir erros no cálculo da sua aposentadoria ou pensão. Fazemos uma análise completa do seu benefício para identificar se há possibilidade de aumento no valor.',
    },
    {
      question: 'Quanto tempo demora um processo no INSS?',
      answer:
        'O prazo varia de acordo com o tipo de benefício e a complexidade do caso. Em média, processos administrativos levam de 45 a 90 dias. Acompanhamos todo o processo e mantemos você informado sobre cada etapa.',
    },
    {
      question: 'O que é aposentadoria especial?',
      answer:
        'Aposentadoria especial é um benefício concedido a trabalhadores expostos a agentes nocivos à saúde, como ruído, calor, frio, produtos químicos, etc. Permite aposentadoria com tempo de contribuição reduzido.',
    },
    {
      question: 'Como posso comprovar tempo de contribuição?',
      answer:
        'O tempo de contribuição pode ser comprovado através de carteira de trabalho, carnês de contribuição, holerites, certidões e outros documentos. Nossa equipe orienta sobre toda a documentação necessária.',
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section
        className="relative min-h-[400px] flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage:
            'linear-gradient(135deg, rgba(45, 66, 56, 0.9) 0%, rgba(45, 66, 56, 0.8) 100%), url(https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=2070)',
        }}
      >
        <div className="container-padding mx-auto text-center relative z-10">
          <div className="max-w-3xl mx-auto space-y-4 slide-up">
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-primary-foreground">
              Nossos Serviços
            </h1>
            <p className="text-lg sm:text-xl text-primary-foreground/90">
              Advogados especialistas em aposentadorias e benefícios
            </p>
          </div>
        </div>
      </section>

      {/* Main Services */}
      <section className="section-padding bg-background">
        <div className="container-padding mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-12 lg:mb-16 slide-up">
            <p className="text-sm font-semibold tracking-widest text-accent uppercase mb-3">
              Previdenciário
            </p>
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-primary mb-4">
              Serviços Disponíveis
            </h2>
            <p className="text-lg text-muted-foreground">
              Assessoria completa em benefícios previdenciários com atendimento personalizado
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {mainServices.map((service, index) => (
              <Card
                key={index}
                className="card-hover border-border hover:border-accent/50 transition-all group"
                style={{ animationDelay: `${index * 0.05}s` }}
              >
                <CardContent className="p-6 space-y-4 flex flex-col h-full">
                  <div className="w-14 h-14 bg-accent-light rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className={`fas ${service.icon} text-2xl text-accent`}></i>
                  </div>
                  <div>
                    <h3 className="font-display text-xl font-semibold text-foreground group-hover:text-accent transition-colors mb-1">
                      {service.title}
                    </h3>
                    <p className="text-sm text-accent font-medium">{service.subtitle}</p>
                  </div>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {service.description}
                  </p>
                  <div className="flex-grow">
                    <ul className="space-y-2">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="text-sm text-muted-foreground flex items-start">
                          <i className="fas fa-check text-accent mr-2 mt-1 flex-shrink-0"></i>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Other Practice Areas */}
      <section className="section-padding bg-secondary">
        <div className="container-padding mx-auto">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12 slide-up">
              <h2 className="font-display text-3xl sm:text-4xl font-bold text-primary mb-4">
                Outras Áreas de Atuação
              </h2>
              <p className="text-lg text-muted-foreground">
                Também atuamos nas áreas trabalhista, tributária e bancária
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {otherAreas.map((service, index) => (
                <Card
                  key={index}
                  className="card-hover border-border"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <CardContent className="p-6 space-y-3">
                    <div className="w-12 h-12 bg-accent-light rounded-lg flex items-center justify-center">
                      <i className={`fas ${service.icon} text-xl text-accent`}></i>
                    </div>
                    <p className="text-xs font-semibold tracking-widest text-accent uppercase">
                      {service.area}
                    </p>
                    <h3 className="font-display text-xl font-semibold text-foreground">
                      {service.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">{service.description}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="section-padding bg-background">
        <div className="container-padding mx-auto">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12 slide-up">
              <h2 className="font-display text-3xl sm:text-4xl font-bold text-primary mb-4">
                Perguntas Frequentes
              </h2>
              <p className="text-lg text-muted-foreground">
                Tire suas dúvidas sobre benefícios previdenciários
              </p>
            </div>

            <Accordion type="single" collapsible className="space-y-4">
              {faq.map((item, index) => (
                <AccordionItem
                  key={index}
                  value={`item-${index}`}
                  className="border border-border rounded-lg px-6 hover:border-accent/50 transition-colors"
                >
                  <AccordionTrigger className="text-left font-semibold text-foreground hover:text-accent">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-gradient-to-r from-primary to-primary-dark text-primary-foreground">
        <div className="container-padding mx-auto">
          <div className="max-w-4xl mx-auto text-center space-y-6 slide-up">
            <h2 className="font-display text-3xl sm:text-4xl font-bold">
              Precisa de Consultoria Especializada?
            </h2>
            <p className="text-lg text-primary-foreground/90">
              Entre em contato conosco para uma análise gratuita do seu caso. Estamos prontos para
              ajudá-lo!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
              <Button
                asChild
                size="lg"
                className="bg-accent hover:bg-accent-hover text-accent-foreground font-semibold px-8 shadow-xl"
              >
                <Link to="/contato">
                  <i className="fas fa-phone-alt mr-2"></i>
                  Fale Conosco
                </Link>
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="border-2 border-primary-foreground/20 text-primary-foreground hover:bg-primary-foreground/10 backdrop-blur-sm font-semibold px-8"
              >
                <Link to="/calculadora">
                  <i className="fas fa-calculator mr-2"></i>
                  Calcular Aposentadoria
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
